export default 
`



 Hugo Document Viewer
 Document:
 CV_A_Muehrenberg.hugodoc

 ┌──────────────────────────┬───┐
 │  /|| _     ,_ | _        │ \\ │
 │ /-||(/_><(|||(|(/_|\`     │  \\│
 │ |\\/|..|_   _ ,_|  _      └───╖
 │ |  |L||||\`(/_|||)(/_|\`(|     ║
 │                       _|     ║
 │ Contact                      ║
 │ 01575 / 66 927 88            ║
 │ alexander@muehrenberg.de     ║
 │                              ║
 │ ―――――――――――――――――――――――――――― ║
 │ Jobs                         ║
 │ ―――――――――――――――――――――――――――― ║
 │   Pirate Ship Software GmbH  ║
 │   - August 2024 - June 2025  ║
 │   - Software Engineer        ║
 │                              ║
 │   aiconix.ai                 ║
 │   - Nov 2021 - Jun 2023      ║
 │   - Software Engineer        ║
 │                              ║
 │   Avocado Store GmbH         ║
 │   - Feb 2021 - Okt 2021      ║
 │   - Software Engineer        ║
 │                              ║
 │   Exporo AG                  ║
 │   - Jun 2019 - Jan 2021      ║
 │   - SRE / Frontend Architect ║
 │                              ║
 │                     Page 1/2 ║
 ╘══════════════════════════════╝
 ┌──────────────────────────────┐
 │   New Work SE                │
 │   - Sep 2015 - Dez 2018      │
 │   - Software Engineer        │   
 │                              │
 │   new-data-services GmbH     │
 │   - Aug 2012 - Jul 2015      │
 │   - Software Engineer        │
 │   - Xing & lebenslauf.com    │
 │                              │
 │   Glückstädter Werkstätten   │
 │   - Aug 2011 - Jul 2012      │
 │   - Social Year              │
 │                              │
 │                              │
 │                              │
 │                              │
 │                              │
 │                              │
 │                              │
 │                     Page 2/2 │
 └──────────────────────────────┘
`